// extracted by mini-css-extract-plugin
export default {"filterIconActive":"ActiveFilterButton_filterIconActive__4vAlx","label":"ActiveFilterButton_label__C-IWA"};